module.exports = __webpack_public_path__ + "img/empty.5481bd72.png";